import { connect } from 'react-redux';
import has from 'lodash/has';
import View from './WorkflowDoneV2View';
import { targetWorkflowIDSelector, clientIDSelector } from './WorkflowDoneV2Selector';

export const RetirementWorkflow = 2;
export const EducationWorkflow = 3;
export const HomePurchaseWorkflow = 4;
export const DebtManagementWorkflow = 5;
export const LargePurchaseWorkflow = 7;
export const EmergencyFundWorkflow = 8;
export const AccountsWorkflow = 9;
export const HealthcareWorkflow = 11;
export const AllWorkflows = 6;
export const RiskTolerance = 12;
export const EstatePlanning = 16;
export const DecumulationWorkflow = 17;

const mapStateToProps = (state, ownProps) => ({
  targetWorkflowID: targetWorkflowIDSelector(state, ownProps),
  clientID: clientIDSelector(state, ownProps),
});

const WORKFLOW_PATH_MAP = {
  [RetirementWorkflow]: 'RetirementWorkflowDone',
  [EducationWorkflow]: 'EducationWorkflowDone',
  [DebtManagementWorkflow]: 'DebtManagementWorkflowDone',
  [HomePurchaseWorkflow]: 'HomePurchaseWorkflowDone',
  [EmergencyFundWorkflow]: 'EmergencyFundWorkflowDone',
  [LargePurchaseWorkflow]: 'LargePurchaseWorkflowDone',
  [AccountsWorkflow]: 'FinancialAccountsWorkflowDone',
  [HealthcareWorkflow]: 'HealthCareWorkflowDone',
  [AllWorkflows]: 'ClientEditPlan',
  [RiskTolerance]: 'RiskToleranceWorkflow',
  [DecumulationWorkflow]: 'DecumulationWorkflowDone',
  [EstatePlanning]: 'ConsumerWorkflowStart',
};

const mapDispatchToProps = () => ({
  onEditMyInformation: (targetWorkflowID, clientID) => () => {
    if (!has(WORKFLOW_PATH_MAP, targetWorkflowID)) {
      throw new Error(`Unknown workflowID: ${targetWorkflowID}`);
    }

    window.ADV.util.Router.go2(WORKFLOW_PATH_MAP[targetWorkflowID], {
      clientId: clientID,
    });
  },
  logout() {
    window.ADV.Controller.logout(true);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
